module.exports = __webpack_public_path__ + "static/media/many.9e399b39.svg";